module.exports = __webpack_public_path__ + "img/image-alt.c4460541.svg";